import React from 'react';
import { FunctionField, TextField, useRefresh } from 'react-admin';
import { List } from '../../../components/List';
import StyledDatagrid from '../../../components/StyledDatagrid';
import { CustomPagination } from '../../../components/CustomPagination';
import { externalRedirect, setDefaultDateFormat } from '../../../utils';
import { DeleteButton, ListHeader } from './components';
import MainListWrapper from '../../../components/MainListWrapper';

const TeammatesList = props => {
  externalRedirect('teammates');
  return (<></>);

  const refresh = useRefresh();
  const { permissions } = props;

  const handleTeammateDeletion = () => {
    refresh();
  };

  return (
    <MainListWrapper>
      <List
        {...props}
        actions={null}
        filters={<ListHeader/>}
        filter={{}}
        bulkActionButtons={false}
        sort={{ field: 'email', order: 'DESC' }}
        pagination={<CustomPagination/>}
      >
        <StyledDatagrid>
          {permissions === 'ROLE_ADMIN' &&
            <FunctionField label="Account ID" render={record => `${record.account.replace('/accounts/', '')}`}/>}
          <TextField label="Email" source="email"/>
          <FunctionField label="Last seen"
            render={({ lastLogin }) => lastLogin ? setDefaultDateFormat(lastLogin) : 'N/A'}/>
          <DeleteButton onSuccess={handleTeammateDeletion}/>
        </StyledDatagrid>
      </List>
    </MainListWrapper>
  );
};

export default TeammatesList;
